import { render } from "./DisplayRules.vue?vue&type=template&id=01272e16"
import script from "./DisplayRules.vue?vue&type=script&lang=js"
export * from "./DisplayRules.vue?vue&type=script&lang=js"

import "./DisplayRules.vue?vue&type=style&index=0&id=01272e16&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__